module.exports = __webpack_public_path__ + "static/media/download.0ae7e86b.svg";